(function () {
  'use strict';

  var overlayOpening = false;

  window.openGlobalOverlay = function (headerOverOverlay) {
    overlayOpening = true;

    var topBar = document.querySelector('.top-bar');
    var mainHeader = document.querySelector('.main-header');
    var header = document.querySelector('.header');

    if (headerOverOverlay && (topBar || mainHeader)) {
      if (topBar) topBar.classList.add('over-overlay');
      if (mainHeader) mainHeader.classList.add('over-overlay');
      if (header) header.classList.add('over-overlay');
    } else {
      if (topBar) topBar.classList.remove('over-overlay');
      if (mainHeader) mainHeader.classList.remove('over-overlay');
      if (header) header.classList.remove('over-overlay');
    }

    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');

    var overlay = document.getElementById('global-overlay');
    if (overlay) {
      overlay.style.display = 'block';
      overlay.style.opacity = '0';
      overlay.offsetHeight;
      overlay.style.transition = 'opacity 150ms';
      overlay.style.opacity = '1';
    }

    setTimeout(function () {
      overlayOpening = false;
    }, 500);
  };

  window.closeGlobalOverlay = function () {
    if (overlayOpening) return;

    var overlay = document.getElementById('global-overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.offsetHeight;

      setTimeout(function () {
        overlay.style.display = 'none';
        document.body.classList.remove('no-scroll');
        document.documentElement.classList.remove('no-scroll');

        var topBar = document.querySelector('.top-bar');
        var mainHeader = document.querySelector('.main-header');
        var header = document.querySelector('.header');

        if (topBar) topBar.classList.remove('over-overlay');
        if (mainHeader) mainHeader.classList.remove('over-overlay');
        if (header) header.classList.remove('over-overlay');
      }, 150);
    } else {
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('no-scroll');
    }
  };

  function initMobileMenu() {
    var menu = document.getElementById('mobile-menu-drawer');
    var overlay = document.getElementById('global-overlay');
    var closeBtn = menu ? menu.querySelector('.mobile-menu__close') : null;
    var startShopping = document.querySelector('#menu-main-mobile-nav > li:first-child');

    if (startShopping) {
      startShopping.classList.add('is-open');
    }

    if (!menu) return;

    function openMenu() {
      var windowWidth = window.innerWidth;

      window.openGlobalOverlay(false);
      document.body.classList.add('mobile-menu-open');

      menu.style.display = 'block';
      menu.style.transition = 'left 150ms ease-out';
      menu.style.left = (-windowWidth) + 'px';

      menu.offsetHeight;
      menu.style.left = '0';
    }

    function closeMenu() {
      if (menu.style.display !== 'block') return;

      var windowWidth = window.innerWidth;

      window.closeGlobalOverlay();
      document.body.classList.remove('mobile-menu-open');

      menu.style.transition = 'left 150ms ease-in';
      menu.style.left = (-windowWidth) + 'px';

      setTimeout(function () {
        menu.style.display = 'none';
      }, 150);
    }

    /* Open menu */
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.header__mobile-nav [data-action="toggle-menu"]');
      if (!toggle) return;

      e.preventDefault();
      e.stopPropagation();
      openMenu();
    }, true);

    /* Close menu button */
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu();
      });
    }

    /* Overlay click closes menu */
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeMenu();
      });
    }

    /* Submenu toggle (RECURSIVE SAFE VERSION) */
    var nav = document.getElementById('menu-main-mobile-nav');

    if (nav) {
      nav.addEventListener('click', function (e) {
        var item = e.target.closest('li.menu-item-has-children');
        if (!item) return;

        var link = e.target.closest('a');
        if (!link) return;

        var submenu = item.querySelector(':scope > .sub-menu');
        if (!submenu) return;

        // Only toggle if clicking the parent label, NOT child links
        if (link.parentElement !== item) return;

        e.preventDefault();
        e.stopPropagation();

        item.classList.toggle('is-open');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initMobileMenu, 0);
    });
  } else {
    setTimeout(initMobileMenu, 0);
  }
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.search-bar__input-clear');
  if (!btn) return;

  const wrapper = btn.closest('.search-bar');
  const input = wrapper?.querySelector('.search-bar__input');

  if (!input) return;

  input.value = '';
  input.classList.remove('is-filled');

  input.focus();

  input.dispatchEvent(new Event('input', { bubbles: true }));
});